import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { TerminalDetailsDto } from '../../../models/terminals/terminalDetailsDto';
import AcceptLabel from '../../common/labels/AcceptLabel';
import DenyLabel from '../../common/labels/DenyLabel';
import { ShowForRole } from '../../common/permissions/ShowForRole';
import { RoleType } from '../../../models/enums/roleType';

interface CaseIntegrityCardProps {
  terminal?: TerminalDetailsDto;
  onResetCaseIntegrityCheck: () => void;
}

export const CaseIntegrityCard: React.FC<CaseIntegrityCardProps> = ({
  terminal,
  onResetCaseIntegrityCheck
}) => (
  <Box className="gbr" px={2} pb={2} sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Typography variant="h5" fontWeight="bold" sx={{ pt: 2, pb: 1 }}>
        Целостность корпуса
      </Typography>

      <ShowForRole role={RoleType.Admin}>
        <IconButton
          className="list-item"
          onClick={onResetCaseIntegrityCheck}
          disabled={terminal?.caseIntact}
          sx={{
            color: (theme) => (terminal?.caseIntact ? theme.palette.action.disabled : 'inherit'),
            opacity: terminal?.caseIntact ? 0.5 : 1,
            mt: 1,
          }}
        >
          <Typography fontWeight="bold">Разблокировать</Typography>
        </IconButton>
      </ShowForRole>
    </Box>

    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
      <Typography className="ltb" variant="body1" mr={1} pt={0}>Состояние</Typography>
      <Typography className="rtb">
        {terminal?.caseIntact ? <AcceptLabel>Не нарушена</AcceptLabel> : <DenyLabel>Нарушена</DenyLabel>}
      </Typography>
    </Box>
  </Box>
);
